<script>
import Layout from '@layouts/default'

export default {
  page: {
    title: 'Frequently Asked Questions | AutoCheck.com',
    meta: [
      { name: 'description', content: 'Frequently Asked Questions' },
      { name: 'keywords', content: 'Frequently Asked Questions' },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/faq',
      },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div id="top" class="col-md-9 col-12 mb-4">
        <h1>
          Frequently Asked Questions about AutoCheck
          <sup style="font-size:13px;">®</sup>
          vehicle history reports
        </h1>
        <hr />
        <ul :class="$style.listTop">
          <li>
            <a v-scroll-to="'#forgot'" class="secondary-anchor-link" href="#"
              >I forgot my AutoCheck.com password. How do I reset it?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#access'" class="secondary-anchor-link" href="#"
              >How do I access my AutoCheck® vehicle history report?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#renew'" class="secondary-anchor-link" href="#"
              >Will my AutoCheck subscription automatically renew?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#returning'" class="secondary-anchor-link" href="#"
              >How do I sign into AutoCheck as a returning customer?</a
            >
          </li>
          <li>
            <a
              v-scroll-to="'#unlimited'"
              class="secondary-anchor-link"
              href="#"
            >
              I subscribed to Multiple Reports but the site won’t let me access
              VINs that I’ve run before.
            </a>
          </li>
          <li>
            <a v-scroll-to="'#buyback'" class="secondary-anchor-link" href="#"
              >Where can I learn more about Buyback Protection?</a
            >
          </li>
          <li>
            <a
              v-scroll-to="'#dontknowvin'"
              class="secondary-anchor-link"
              href="#"
            >
              Can I buy a report if I don't know the vehicle's VIN or license
              plate?
            </a>
          </li>
          <li>
            <a v-scroll-to="'#info'" class="secondary-anchor-link" href="#"
              >What type of information does AutoCheck provide?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#sample'" class="secondary-anchor-link" href="#"
              >Can I view a sample report?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#score'" class="secondary-anchor-link" href="#"
              >What is the patented AutoCheck Score™?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#where'" class="secondary-anchor-link" href="#"
              >Where does AutoCheck's vehicle history data come from?</a
            >
          </li>
          <li>
            <a v-scroll-to="'#when'" class="secondary-anchor-link" href="#">
              When I enter my VIN or license plate I receive a "no history
              found" message – what does this mean?
            </a>
          </li>
          <li>
            <a v-scroll-to="'#can'" class="secondary-anchor-link" href="#">
              Can I get a vehicle history report for a vehicle manufactured for
              a market outside the United States or Canada?
            </a>
          </li>
          <li>
            <a v-scroll-to="'#contact'" class="secondary-anchor-link" href="#"
              >How do I contact Customer Service?</a
            >
            <br />&nbsp;
          </li>
        </ul>
        <div id="forgot">
          <p>
            &nbsp;
            <br />
            <b>I forgot my AutoCheck.com password. How do I reset it?</b>
            <br />A password is required to access the AutoCheck.com site.
            <BaseLink :to="{ name: 'login' }">
              Please go to the Account Sign In page and click on the “Unable to Sign in? Reset Your Password” link. </BaseLink
            >You will be asked to submit the email address associated with your
            AutoCheck account. Instructions on how to reset your password will
            be sent to that email address.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="access">
          <p>
            &nbsp;
            <br />
            <b>How do I access my AutoCheck® vehicle history report?</b>
            <br />All of your purchased reports can be viewed online via your
            <u>VHR dashboard</u> for the duration of your subscription term. If
            your subscription expires, then simply click on “Activate” from
            within your dashboard to renew your subscription and restore access
            to your reports.
            <br />
            <img
              src="images/dashboard-activate-medium.jpg"
              width="100%"
              alt="dashboard activate sample"
            />
          </p>
          <p>
            If you purchased a report without a VIN simply sign in to your
            account and enter a VIN or license plate number anywhere you see a
            VIN Check box on the site.
            <!--
<div class="rhtBtn">
            <div id="test_vinComponent_vinSearchButton_$9" style="display:inline"><button type="button" id="vinSearch" class="left btn bgNone check-vin"> <span>Check VIN</span> </button></div>-->
            <br />
            <img
              src="images/checkvin.gif"
              width="131"
              height="67"
              alt="VIN check"
            />
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="renew">
          <p>
            &nbsp;
            <br />
            <b>Will my AutoCheck subscription automatically renew?</b>
            <br />No: Your credit card will be charged only when you purchase
            your subscription or choose to renew or extend your subscription. If
            your account expires we will keep your VIN history safe and locked
            away in case you wish to access them again once you reactivate your
            account.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="returning">
          <p>
            &nbsp;
            <br />
            <b>How do I sign into AutoCheck as a returning customer?</b>
            <br />To sign in to your account click on “
            <BaseLink :to="{ name: 'login' }"
              >AutoCheck Subscriber? Sign In</BaseLink
            >” in the top right hand corner of the site. Be sure to use the
            email address associated with your AutoCheck account. If you forgot
            your password simply click on “Unable to Sign in? Reset Your Password” and you’ll
            receive an email that will direct you on how to reset your password.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="unlimited">
          <p>
            &nbsp;
            <br />
            <b>
              I subscribed to Multiple Reports but the site won’t let me access
              VINs that I’ve run before.
            </b>
            <br />Your subscription may have expired. From your VHR Dashboard
            click on “Activate” to select a report plan and renew your
            subscription.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="buyback">
          <p>
            &nbsp;
            <br />
            <b>Where can I learn more about Buyback Protection?</b>
            <br />Learn more about Buyback Protection including what it is, what
            it covers and how to take advantage of it on our
            <BaseLink :to="{ name: 'vehicle-buyback-protection' }"
              >Buyback Protection information page</BaseLink
            >»
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="dontknowvin">
          <p>
            &nbsp;
            <br />
            <b>
              Can I buy a report if I don't know the vehicle's VIN or license
              plate?
            </b>
            <br />Yes! Many of our customers like to purchase Multiple Reports
            before they visit the Auto Dealership so that they can enter VINs
            while they shop the lot. Simply choose your preferred report plan
            and complete checkout. When you’re ready to run a report, sign in
            and enter a VIN or U.S. license plate to get the report.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="info">
          <p>
            &nbsp;
            <br />
            <b>What type of information does AutoCheck provide?</b>
            <br />AutoCheck provides information about the vehicle's title,
            registration and usage history. Each report displays the results of
            our comprehensive search for salvage or junk vehicles; damage from
            hail, flood or fire; mileage discrepancies or odometer rollback; and
            gray market vehicles. AutoCheck also looks for lemon vehicles;
            vehicles designated as rentals, taxis or fleet usage; abandoned or
            forfeited vehicles; records of theft; and loan/liens that represent
            ownership interests or unpaid judgments. AutoCheck reports on
            accident damage when that information is provided to it. AutoCheck
            does NOT provide the names of or information pertaining to a
            vehicle's previous owner(s). AutoCheck may not provide information
            on every accident in which a vehicle may have been involved.
            <BaseLink :to="{ name: 'backed-by-experian' }"
              >Learn more about our data sources</BaseLink
            >»
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="sample">
          <p>
            &nbsp;
            <br />
            <b>Can I view a sample report?</b>
            <br />Yes, you can:
            <BaseLink :to="{ name: 'sample-report' }"
              >View a sample report</BaseLink
            >»
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="score">
          <p>
            &nbsp;
            <br />
            <b>What is the patented AutoCheck Score™?</b>
            <br />The AutoCheck Score helps predict the likelihood the car will
            be on the road in 5 years. Only AutoCheck has the patented AutoCheck
            Score to help you assess a vehicle's predicted reliability and
            compare it to similar cars in its class. This information helps to:
          </p>
          <ul>
            <li>
              Compare vehicles of similar class and age based on a scale of 1 to
              100
            </li>
            <li>
              Predict the reliability your car will be on the road in 5 years
            </li>
            <li>
              Understand a vehicle’s reliability as it pertains to vehicle’s
              age, number of owners and accidents
            </li>
            <li
              >Lower the risk of buying a vehicle with undetected problems.</li
            >
          </ul>
          <p>
            More information on the
            <BaseLink :to="{ name: 'autocheck-score' }"
              >AutoCheck Score</BaseLink
            >»
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="where">
          <p>
            &nbsp;
            <br />
            <b>Where does AutoCheck's vehicle history data come from?</b>
            <br />Information provided in an AutoCheck vehicle history report
            comes from hundreds of data sources. These include: state
            departments of motor vehicles (DMVs), auto auctions, Canadian motor
            vehicle departments, consumer protection agencies, auto dealers and
            other state agencies. All data acquired from these sources meet
            either the federally mandated Drivers Privacy Protection Act (DPPA)
            and/or other industry guidelines.
            <BaseLink :to="{ name: 'backed-by-experian' }"
              >More information on AutoCheck vehicle history data</BaseLink
            >»
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="when">
          <p>
            &nbsp;
            <br />
            <b>
              When I enter my VIN or license plate I receive a "no history
              found" message – what does this mean?
            </b>
            <br />A "No Records Found" message means that our vehicle history
            data search found no information in that category at this point in
            time. It could mean that the car was manufactured before 1981 and it
            doesn't have the vehicle information number (VIN) we need to find
            the answers you're looking for. It could also mean that the car is
            so new that there are no records currently on file. Check back soon,
            once it's had some time on the road.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="can">
          <p>
            &nbsp;
            <br />
            <b>
              Can I get a vehicle history report for a vehicle manufactured for
              a market outside the United States or Canada?
            </b>
            <br />Not at this time. AutoCheck only reports on vehicles
            manufactured for US and Canadian markets.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
        <div id="contact">
          <p>
            &nbsp;
            <br />
            <b>How do I contact Customer Service?</b>
            <br />Please use our
            <BaseLink :to="{ name: 'contact' }">Contact Us form</BaseLink> to
            contact Customer Service or call us directly at 888-409-2204 for
            assistance with your subscription. If you need help regarding a
            specific report you've ordered from AutoCheck, please be sure to
            include your VIN, Transaction ID and Order ID.
            <br />
            <a v-scroll-to="'#top'" class="secondary-anchor-link" href="#"
              >Back to Top »</a
            >
          </p>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="content-page-right-navigation gray">
          <p style="text-align: left;">
            <b style="font-size: 14px;">Additional Resources</b>
          </p>
          <ul style="border-top: 0 solid #d0d0d0;">
            <li>
              <BaseLink :to="{ name: 'home' }">Check Your VIN/Plate</BaseLink>
            </li>
            <li>
              <BaseLink :to="{ name: 'contact' }">Contact Us</BaseLink>
            </li>
          </ul>
          <p style="text-align: left;">
            &nbsp;
            <br />
            <b style="font-size:14px">AutoCheck Subscriber?</b>
          </p>
          <ul style="border-top: 0 solid #d0d0d0;">
            <li>
              <BaseLink :to="{ name: 'login' }">Sign in Now</BaseLink>
            </li>
            <li>
              <BaseLink :to="{ name: 'secure-shopping' }"
                >Secure Shopping</BaseLink
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.listTop {
  li {
    margin-bottom: 10px;
  }
}
</style>
